<div>
  <div>
    <div class="card card_outLine">
      <div class="card-body">
        <h5 class="title_five">Product Details</h5>
        <form [formGroup]="productDetails">
          <div class="row">
            <div class="col-lg-3 col-sm-3 col-md-3">
              <span class="form_field"> Branch</span>
              <div class="custom-input">
                <input
                  class="readOnly grey_background"
                  type="text"
                  pInputText
                  readOnly="true"
                  formControlName="branchName"
                />
                <span class="p-error" style="font-size: 0.5rem" *ngIf="noBranch"
                  >Please Select a Branch
                </span>
              </div>
            </div>
            <div class="col-lg-3 col-sm-3 col-md-3">
              <span class="form_field">
                Template <span class="color_red">*</span></span
              >
              <div class="row overlay_1">
                <app-dropdown
                  class="custom-dropdown"
                  [options]="allTemplateDoc"
                  [filter]="true"
                  filterBy="name"
                  formControlName="documentType"
                  placeholder="Select Template"
                  optionLabel="name"
                  [sort]="false"                
                ></app-dropdown>
                <span
                  class="p-error"
                  style="font-size: 0.5rem"
                  *ngIf="
                    submitted &&
                    productDetails.get('documentType')?.hasError('required')
                  "
                  >Select Template</span
                >
              </div>
            </div>
            <div class="col-lg-3 col-sm-3 col-md-3">
              <span class="form_field">
                {{
                  showHdfcFields
                    ? "File number (As per HDFC Bank Sanction letter)"
                    : "Reference
                Number"
                }}
                <span class="color_red">*</span></span
              >
              <div class="custom-input">
                <input
                  type="text"
                  pInputText
                  formControlName="referenceNumber"
                  placeholder="Allows alphabets ,numbers and hyphen"
                  [ngClass]="enableRefIdField ? '' : 'grey_background'"
                  onkeypress="return (event.charCode >= 65 && event.charCode <= 90) || 
                       (event.charCode >= 97 && event.charCode <= 122) || 
                       (event.charCode >= 48 && event.charCode <= 57) || 
                       (event.charCode === 45) || (event.charCode === 95)"
                  (paste)="onReferencePaste($event)"
                  [readOnly]="!enableRefIdField"
                />
                <span
                  class="p-error"
                  style="font-size: 0.5rem"
                  *ngIf="
                    submitted &&
                    productDetails.get('referenceNumber')?.hasError('required')
                  "
                  >Enter reference No.</span
                >
                 <span
                class="p-error"
                style="font-size: 0.8rem; display: block; padding-top: 0.2rem;"
                *ngIf="productDetails.get('referenceNumber')?.hasError('maxlength')"
                     > *Maximum 80 characters allowed
                </span>
                <span
                  class="p-error"
                  style="font-size: 0.8rem; display: block; padding-top: 0.2rem;"
                  *ngIf="productDetails.get('referenceNumber')?.hasError('invalidChars') && productDetails.get('referenceNumber')?.touched">
                  *Only alphabets, numbers, _ and - are allowed
                </span>
              </div>
            </div>
          </div>
        </form>

        <div class="text-right">
          <p-button
            label="Next"
            (click)="gotoTemplatePage()"
            styleClass="p-button-sm-outline"
          ></p-button>
        </div>
      </div>
    </div>
  </div>
</div>
